<div class="container-fluid mt-3">
  <h4>Proxy</h4>

  <!-- Toolbar -->
  <div class="row mb-3 align-items-end">
    <div class="col-md-3 form-group mb-0">
      <input class="form-control" placeholder="Tìm kiếm host, user, note..."
             [(ngModel)]="query.queryString" (keyup.enter)="search()" />
    </div>
    <div class="col-md-2 form-group mb-0">
      <ng-select [items]="sources" bindValue="id" bindLabel="name"
                 placeholder="Nguồn" [(ngModel)]="query.sourceId"
                 (change)="search()"></ng-select>
    </div>
    <div class="col-md-2 form-group mb-0">
      <ng-select [items]="statusOptions" bindValue="id" bindLabel="name"
                 placeholder="Trạng thái" [(ngModel)]="query.status"
                 (change)="search()"></ng-select>
    </div>
    <div class="col-md-2 form-group mb-0">
      <ng-select [items]="protocolOptions" bindValue="id" bindLabel="name"
                 placeholder="Protocol" [(ngModel)]="query.protocol"
                 (change)="search()"></ng-select>
    </div>
    <div class="col-md-2 form-group mb-0">
      <ng-select [items]="merchantTypeOptions" bindValue="id" bindLabel="name"
                 placeholder="Có thể dùng cho..." [(ngModel)]="query.availableForMerchantType"
                 (change)="search()"></ng-select>
    </div>
    <div class="col-md-1 form-group mb-0 d-flex">
      <button class="btn btn-primary mr-1" (click)="search()">
        <i class="fas fa-search"></i>
      </button>
      <button class="btn btn-outline-secondary" (click)="clearSearch()" title="Xóa bộ lọc">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="mb-2">
    <button class="btn btn-primary btn-sm mr-2" (click)="openImportModal()">
      <i class="fas fa-file-import"></i> Import
    </button>
    <button class="btn btn-outline-secondary btn-sm mr-2" (click)="doExport()" [disabled]="selectedIds.size === 0">
      <i class="fas fa-file-export"></i> Export ({{ selectedIds.size }})
    </button>
    <button class="btn btn-outline-success btn-sm mr-2" (click)="openExtendModal()">
      <i class="fas fa-calendar-plus"></i> Gia hạn
    </button>
  </div>

  <!-- Grid -->
  <div class="table-responsive">
    <table class="table table-bordered table-sm table-hover">
      <thead class="thead-light">
        <tr>
          <th style="width:30px">
            <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" />
          </th>
          <th>Proxy IP</th>
          <th>Proxy Port</th>
          <th>User/Pass</th>
          <th>Status</th>
          <th>Nguồn</th>
          <th>Country</th>
          <th>Start</th>
          <th>End</th>
          <th class="text-center" style="min-width:120px">Tự động gia hạn</th>
          <th class="text-right" style="min-width:100px">Chi phí / tháng (USD)</th>
          <th class="text-right" style="min-width:100px">Tổng chi phí (USD)</th>
          <th>Note</th>
          <th style="min-width:250px">Đang dùng</th>
          <th style="width:100px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of proxies">
          <td><input type="checkbox" [checked]="isSelected(p.id)" (change)="toggleSelect(p.id)" /></td>
          <td>{{ p.host }}</td>
          <td class="proxy-port-cell">
            <div *ngIf="p.socks5Port" class="port-line">
              <span class="port-label">SOCKS5</span>
              <span class="port-value">{{ p.socks5Port }}</span>
            </div>
            <div *ngIf="p.httpsPort" class="port-line">
              <span class="port-label">HTTP</span>
              <span class="port-value">{{ p.httpsPort }}</span>
            </div>
          </td>
          <td class="userpass-cell">
            <div>{{ p.username }}</div>
            <div class="text-muted">{{ p.password }}</div>
          </td>
          <td>
            <span class="badge" [ngClass]="getStatusClass(p.status)">{{ getStatusLabel(p.status) }}</span>
          </td>
          <td>{{ p.proxySource?.name }}</td>
          <td>{{ p.country }}</td>
          <td>
            <input type="date" class="form-control form-control-sm inline-edit"
                   [ngModel]="p.startDate | date:'yyyy-MM-dd'"
                   (change)="inlineSaveDate(p, 'startDate', $event)" />
          </td>
          <td>
            <input type="date" class="form-control form-control-sm inline-edit"
                   [ngModel]="p.endDate | date:'yyyy-MM-dd'"
                   (change)="inlineSaveDate(p, 'endDate', $event)" />
          </td>
          <td class="text-center align-middle">
            <div class="custom-control custom-switch proxy-auto-renew-switch d-inline-flex justify-content-center">
              <input type="checkbox" class="custom-control-input" [id]="'autoRenew-' + p.id"
                     [checked]="p.autoRenew !== false"
                     (change)="toggleAutoRenew(p, $event)">
              <label class="custom-control-label mb-0" [for]="'autoRenew-' + p.id"></label>
            </div>
          </td>
          <td class="text-right">
            <input type="number" step="0.01" min="0" class="form-control form-control-sm inline-edit text-right"
                   [ngModel]="p.costPerMonth"
                   (blur)="inlineSaveCostPerMonth(p, $event)" />
          </td>
          <td class="text-right">
            <span class="badge badge-cost badge-cost-total">
              <i class="fas fa-dollar-sign"></i> {{ p.totalCost | number:'1.2-2' }}
            </span>
          </td>
          <td>
            <input class="form-control form-control-sm inline-edit"
                   [ngModel]="p.note"
                   (blur)="inlineSaveNote(p, $event)"
                   (keyup.enter)="$event.target.blur()" />
          </td>
          <td>
            <div *ngFor="let u of p.proxyUsages" class="d-flex align-items-center mb-1">
              <input type="checkbox" [checked]="u.isActive" (change)="toggleUsageActive(u)" class="mr-1" />
              <small [class.text-muted]="!u.isActive" class="mr-1">{{ getUsageLabel(u) }}</small>
              <button *ngIf="canDelete" class="btn btn-xs btn-outline-danger p-0 px-1" style="font-size:10px;line-height:1.2"
                      (click)="deleteUsage(u.id)" title="Remove">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <button class="btn btn-xs btn-outline-primary p-0 px-1" style="font-size:10px;line-height:1.2"
                    (click)="openAddUsageModal(p.id)" title="Add usage">
              <i class="fas fa-plus"></i>
            </button>
          </td>
          <td>
            <button class="btn btn-sm btn-outline-primary mr-1" (click)="openEditModal(p)" title="Sửa">
              <i class="fas fa-edit"></i>
            </button>
            <button *ngIf="canDelete" class="btn btn-sm btn-outline-danger" (click)="deleteProxy(p.id)" title="Xóa">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="proxies.length === 0">
          <td colspan="15" class="text-center text-muted">Không có dữ liệu</td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-pagination [totalItems]="total" [pageSize]="query.pageSize" [pageNumber]="query.pageNumber"
                  (onPageChanged)="onPageChange($event)"></app-pagination>
</div>

<!-- Import Modal -->
<ng-template #importModal let-modal>
  <app-proxy-import-modal (imported)="onImported()"></app-proxy-import-modal>
</ng-template>

<!-- Add Usage Modal -->
<ng-template #addUsageModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Thêm Usage</h5>
    <button class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Merchant</label>
      <ng-select [items]="merchants" [bindValue]="'merchantId'" [bindLabel]="'name'"
                 placeholder="Chọn merchant (để trống nếu khác)..."
                 [(ngModel)]="addUsageMerchantId">
        <ng-template ng-label-tmp let-item="item">
          {{ getMerchantLabel(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ getMerchantLabel(item) }}
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group">
      <label>Ghi chú</label>
      <input class="form-control" [(ngModel)]="addUsageNote" placeholder="Mục đích sử dụng khác..." />
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="usageActive" [(ngModel)]="addUsageIsActive">
        <label class="custom-control-label" for="usageActive">Đang sử dụng</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()">Hủy</button>
    <button class="btn btn-primary" (click)="saveUsage()">Lưu</button>
  </div>
</ng-template>

<!-- Edit Proxy Modal -->
<ng-template #editProxyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Sửa Proxy</h5>
    <button class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-4 form-group">
        <label>Host</label>
        <input class="form-control" [(ngModel)]="editingProxy.host" />
      </div>
      <div class="col-md-4 form-group">
        <label>SOCKS5 Port</label>
        <input class="form-control" type="number" [(ngModel)]="editingProxy.socks5Port" placeholder="Optional" />
      </div>
      <div class="col-md-4 form-group">
        <label>HTTPS Port</label>
        <input class="form-control" type="number" [(ngModel)]="editingProxy.httpsPort" placeholder="Optional" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Username</label>
        <input class="form-control" [(ngModel)]="editingProxy.username" />
      </div>
      <div class="col-md-6 form-group">
        <label>Password</label>
        <input class="form-control" [(ngModel)]="editingProxy.password" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Country</label>
        <input class="form-control" [(ngModel)]="editingProxy.country" placeholder="VN, US, UK..." />
      </div>
      <div class="col-md-6 form-group">
        <label>Status</label>
        <ng-select [items]="statusOptions.slice(1)" bindValue="id" bindLabel="name"
                   [(ngModel)]="editingProxy.status"></ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Start Date</label>
        <input class="form-control" type="date" [(ngModel)]="editingProxy.startDate" />
      </div>
      <div class="col-md-6 form-group">
        <label>End Date</label>
        <input class="form-control" type="date" [(ngModel)]="editingProxy.endDate" />
      </div>
    </div>
    <div class="form-group">
      <label>Nguồn proxy</label>
      <ng-select [items]="sources" bindValue="id" bindLabel="name"
                 placeholder="Chọn nguồn..."
                 [(ngModel)]="editingProxy.proxySourceId"></ng-select>
    </div>
    <div class="form-group">
      <label>Chi phí / tháng (USD)</label>
      <app-all-to-usd [(des)]="editingProxy.costPerMonth"></app-all-to-usd>
      <small class="text-muted d-block">Dùng cho gia hạn thủ công và tự động gia hạn.</small>
    </div>
    <div class="form-group">
      <label>Tổng chi phí đã trả (USD)</label>
      <app-all-to-usd [(des)]="editingProxy.totalCost"></app-all-to-usd>
      <small class="text-muted d-block">Cộng dồn khi gia hạn hoặc gia hạn tự động.</small>
    </div>
    <div class="form-group">
      <div class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" id="editAutoRenew" [(ngModel)]="editingProxy.autoRenew">
        <label class="custom-control-label" for="editAutoRenew">Tự động gia hạn (30 ngày + chi phí / tháng khi hết hạn)</label>
      </div>
    </div>
    <div class="form-group">
      <label>Ghi chú</label>
      <textarea class="form-control" rows="2" [(ngModel)]="editingProxy.note"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()">Hủy</button>
    <button class="btn btn-primary" (click)="saveEditProxy()">Lưu</button>
  </div>
</ng-template>

<!-- Extend (Gia hạn) Modal -->
<ng-template #extendModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      Gia hạn Proxy
      <span *ngIf="selectedIds.size > 0" class="text-muted">({{ selectedIds.size }} proxy đã chọn)</span>
    </h5>
    <button class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div *ngIf="selectedIds.size === 0" class="form-group">
      <label>Danh sách proxy <small class="text-muted">(Host — mỗi dòng một IP)</small></label>
      <textarea class="form-control" rows="6" [(ngModel)]="extendLines"
                placeholder="103.152.112.186&#10;45.77.134.91"></textarea>
    </div>
    <div class="form-group">
      <label>Số ngày gia hạn</label>
      <ng-select [items]="extendDayOptions" bindValue="value" bindLabel="label"
                 [(ngModel)]="extendDays" placeholder="Chọn số ngày..."></ng-select>
    </div>
    <div class="form-group">
      <label>Số tiền</label>
      <app-all-to-usd [(des)]="extendCostUsd"></app-all-to-usd>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()">Hủy</button>
    <button class="btn btn-success" (click)="doExtend()" [disabled]="!extendDays || !extendCostUsd">
      <i class="fas fa-calendar-plus"></i> Gia hạn
    </button>
  </div>
</ng-template>

<!-- Export Modal -->
<ng-template #exportModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Export Proxies</h5>
    <button class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <textarea class="form-control" rows="10" readonly>{{ exportText }}</textarea>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="copyExport()">
      <i class="fas fa-copy"></i> Copy
    </button>
    <button class="btn btn-light" (click)="modal.dismiss()">Đóng</button>
  </div>
</ng-template>
